/**
 * Checks if subscription is paid based on type and subscription data
 * @param {string} type - Subscription type (vat, sales tax, epr, omp)
 * @param {Object} sub - Subscription object
 * @param {Object} currentPlan - Current plan object
 * @returns {boolean} - True if subscription is paid
 */
export const isPaidSubscription = (type, sub, currentPlan) => {
	// Check subscription status
	if (sub?.status === 'trial' || sub?.status === 'free') {
		return false
	}

	// Check sum - if greater than 0, then paid
	let sum = 0
	switch (type) {
		case "vat":
			sum = currentPlan.subscriptions?.sum || 0
			break
		case "sales tax":
			sum = currentPlan?.subscriptions_sales_tax?.sum || 0
			break
		case "epr":
			sum = currentPlan?.subscriptions_epr?.sum || 0
			break
		case "omp":
			sum = currentPlan?.subscriptions_omp?.sum || 0
			break
		case "invoice":
			sum = currentPlan?.subscriptions_invoice?.sum ?? currentPlan?.subscriptions_invoice?.subscriptions?.sum ?? 0
			// Invoice can be paid (active) even when sum is 0 (e.g. tariff_plan.price: 0)
			if (currentPlan?.subscriptions_invoice?.is_active) return true
			return sum > 0
	}

	return sum > 0
}

/**
 * Checks if subscription component should be shown
 * @param {Object} params - Parameters object
 * @param {boolean} params.fetchingPaymentInfo - Is payment info being fetched
 * @param {Object} params.currentPlan - Current plan object
 * @param {string} params.openProjectName - Open project name
 * @returns {boolean} - True if component should be shown
 */
export const shouldShowSubscription = ({ fetchingPaymentInfo, currentPlan, openProjectName }) => {
	return fetchingPaymentInfo ||
		currentPlan?.subscriptions?.status === 'trial' ||
		(openProjectName === 'LTax' && currentPlan?.subscriptions) ||
		(openProjectName === 'LTax' && currentPlan?.subscriptions_sales_tax) ||
		(openProjectName === 'LTax' && currentPlan?.subscriptions_omp) ||
		(openProjectName === 'LEPR' && currentPlan?.subscriptions_epr) ||
		(openProjectName === 'LInvoice' && currentPlan?.subscriptions_invoice)
}

